import { ClusteringConfigurationSliceState } from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationSlice'

export const selectFetchClusteringStatus = (store: any) => {
  const clusteringConfigState: ClusteringConfigurationSliceState = store.clusteringConfigurationSlice
  return clusteringConfigState.fetchClusteringStatusRequest
}

export const selectClusteringExecutionId = (store: any) => {
  const clusteringConfigState: ClusteringConfigurationSliceState = store.clusteringConfigurationSlice
  return clusteringConfigState.activeClusteringExecutionId
}
